var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "{this.props.width}",
    height: "{this.props.height}",
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4444 0C8.11708 0 4.60905 3.47939 4.60905 7.77143C4.60905 12.0635 8.11708 15.5429 12.4444 15.5429C16.7718 15.5429 20.2798 12.0635 20.2798 7.77143C20.2798 3.47939 16.7718 0 12.4444 0Z",
    fill: "{this.props.fill}"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0684 19.0003C14.0051 18.5154 10.8838 18.5154 7.82052 19.0003L7.49217 19.0523C3.17595 19.7355 0 23.4281 0 27.7633C0 30.1031 1.91247 32 4.27161 32H20.6173C22.9764 32 24.8889 30.1031 24.8889 27.7633C24.8889 23.4281 21.7129 19.7355 17.3967 19.0523L17.0684 19.0003Z",
    fill: "{this.props.fill}"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneUserIcon);
export default __webpack_public_path__ + "static/media/oneUserIcon.6c34a5a7a4168ba0751d19aa0b28a5de.svg";
export { ForwardRef as ReactComponent };